import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Gateway from "@/pages/Gateway";
import BrandSite from "@/pages/BrandSite";

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <Routes>
          <Route path="/" element={<Gateway />} />
          <Route path="/:brandKey" element={<BrandSite />} />
        </Routes>
      </SmoothScroll>
      <Toaster position="bottom-right" richColors />
    </BrowserRouter>
  );
}

export default App;
